// src/data/_creatorData.js

export const creators = [
  {
    // This is the data moved from the old 'mockCreator' object
    username: "gigiMusic",
    fullName: "Gigi Kiya",
    isVerified: true,
    profilePictureUrl: "https://i.pravatar.cc/100?u=gigi",
    bannerUrl:
      "https://placehold.co/400x160/1E293B/FFFFFF?text=Gigi+Kiya+Live&font=lora",
    bio: "Renowned Ethiopian singer blending traditional sounds with modern vibes. Welcome to my official hub!",
    stats: {
      followers: "1.2M",
      likes: "45K",
      posts: "120"
    },
    posts: [
      {
        id: 1,
        type: "video",
        title: "Studio Session: New Single Preview!",
        isPremium: true,
        comments: 120,
        likes: 2500,
        status: "Published",
        publishDate: "2025-10-08",
      },
      {
        id: 2,
        type: "text",
        content:
          "So excited to announce my upcoming concert in Addis! Can't wait to see you all there. Get your tickets now!",
        isPremium: false,
        comments: 350,
        likes: 5200,
        status: "Published",
        publishDate: "2025-10-06",
      },
      {
        id: 3,
        type: "image",
        title: "Photoshoot Sneak Peek",
        isPremium: true,
        comments: 85,
        likes: 1800,
        status: "Draft",
        publishDate: "2025-10-15",
      },
    ],
    events: [
      {
        id: 1,
        type: "Virtual",
        title: "Live Acoustic Session",
        date: "Oct 25, 2025",
        priceETB: 500,
        ticketsSold: 150,
        status: "Upcoming",
      },
      {
        id: 2,
        type: "Live",
        title: "Unity Concert",
        date: "Nov 12, 2025",
        priceETB: 1200,
        ticketsSold: 850,
        status: "Upcoming",
      },
      {
        id: 3,
        type: "Live",
        title: "Album Launch Party",
        date: "Sep 05, 2025",
        priceETB: 420,
        ticketsSold: 500,
        status: "Past",
      },
    ],
    merchandise: [
      {
        id: 1,
        name: "Signature 'Gigi' Hoodie",
        priceETB: 1800,
        imageUrl: "https://placehold.co/200x200/334155/FFFFFF?text=Hoodie",
        stock: 50,
        sales: 120,
      },
      {
        id: 2,
        name: "Autographed Album Poster",
        priceETB: 950,
        imageUrl: "https://placehold.co/200x200/334155/FFFFFF?text=Poster",
        stock: 150,
        sales: 350,
      },
      {
        id: 3,
        name: "Custom Phone Case",
        priceETB: 600,
        imageUrl: "https://placehold.co/200x200/334155/FFFFFF?text=Case",
        stock: 25,
        sales: 85,
      },
    ],
    courses: [
      {
        id: "C01",
        title: "The Fundamentals of Modern Ethiopian Music",
        priceETB: 4500,
        hitLink: "https://hit.edu/course/ethio-music-101",
      },
      {
        id: "C02",
        title: "Advanced Vocal Techniques",
        priceETB: 6000,
        hitLink: "https://hit.edu/course/vocals-201",
      },
    ],
    experiences: [
      { id: 1, title: "Personalized Birthday Video", priceETB: 2500 },
      { id: 2, title: "1-on-1 Music Feedback Session", priceETB: 7000 },
    ],
    donationCampaigns: [
      {
        id: "DC-GIGI-01",
        title: "Local Artists Support Fund",
        beneficiary: "Self-Managed Artist Collective",
        goalETB: 100000,
        raisedETB: 75000,
        // ✨ NEW: Status for admin review
        status: "Approved",
        isCreatorSubmitted: true,
      },
      {
        id: "DC-GIGI-02",
        title: "Addis Animal Shelter Drive",
        beneficiary: "City Animal Welfare Group",
        goalETB: 50000,
        raisedETB: 0,
        status: "Pending", // This one is waiting for admin approval
        isCreatorSubmitted: true,
      },
    ],
    subscriptionProducts: [
      {
        id: 1,
        name: "Fan Club",
        type: "Adnaki Content", // Internal Adnaki subscription
        platform: "Adnaki",
        logoUrl: "https://placehold.co/40x40/F1F5F9/7C3AED?text=A", // Generic Adnaki Logo
        priceETB: 75,
        perks: [
          "Exclusive updates",
          "Fan badge on profile",
          "Early access to music videos",
        ],
      },
      {
        id: 2,
        name: "VIP Circle",
        type: "Adnaki Content", // Internal Adnaki subscription
        platform: "Adnaki",
        logoUrl: "https://placehold.co/40x40/F1F5F9/7C3AED?text=A",
        priceETB: 350,
        perks: [
          "All Fan Club perks",
          "Behind-the-scenes-content",
          "Monthly virtual Q&A session",
        ],
      },
      {
        id: 3,
        name: "Sewasew Weekly",
        type: "External Platform", // New External subscription
        platform: "Sewasew",
        logoUrl: "https://placehold.co/40x40/10B981/FFFFFF?text=S", // Placeholder Sewasew Logo
        priceETB: 50,
        perks: [
          "Weekly access to my full catalog on Sewasew",
          "Offline downloads",
          "High-quality audio",
        ],
      },
      {
        id: 4,
        name: "Sewasew Monthly",
        type: "External Platform", // New External subscription
        platform: "Sewasew",
        logoUrl: "https://placehold.co/40x40/10B981/FFFFFF?text=S",
        priceETB: 180,
        perks: [
          "Monthly access to my full catalog on Sewasew",
          "Offline downloads & exclusive playlists",
          "High-quality audio",
        ],
      },
    ],
  },
];
